import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppProvider } from "hooks/useApp";
import { DataProvider } from "hooks/useData";
import { ContextProvider } from "utilities/ContextProvider";
import { UnityProvider } from "hooks/UseUnity";
import { WebStorageStateStore } from "oidc-client-ts";
import { AuthProvider } from "react-oidc-context";
import { ScreenProvider } from "hooks/useScreen";
import ModalProvider from "hooks/ModalProvider";
import { CoordinatesProvider } from "hooks/useCoordinates";
import { ProjectsCoordinatesProvider } from "hooks/CoordinatesContext";
import { TabProvider } from "hooks/useAssetsActiveTab";
import { MinifiedMenuItemsProvider } from "hooks/useMinifiedMenu";
import { UnityActionsProvider } from "hooks/unityActions";
import { LocationsMenuProvider } from "hooks/useUnityLocations";
import { FileUploadProvider } from "hooks/FilesUploadContext";
import { MeasurementsProvider } from "hooks/MeasurementsContext";
import { getExtractedPath, setExtractedPath } from "utilities/extractedPath";
import { VolumeProvider } from "hooks/useProjectVolume";
import { AiChatProvider } from "hooks/AiChatContext";
import { OrganizationProvider } from "hooks/OrganizationContext";
import { bootstrapStoredThemeColors, bootstrapStoredThemeMode } from "utilities/themeColors";

setExtractedPath();
bootstrapStoredThemeColors();
bootstrapStoredThemeMode();

const baseUrl = getExtractedPath();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const oidcConfig = {
  client_id: `${process.env.REACT_APP_CLIENT_ID}`,
  client_secret: `${process.env.REACT_APP_CLIENT_SECRET}`,
  authority: `${process.env.REACT_APP_AUTH_APP}`,
  redirect_uri: `${process.env.REACT_APP_PM_APP}`,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: (user: any) => {
    window.history.replaceState(
      {},
      window.document.title,
      window.location.origin + window.location.pathname
    );
    window.location = user.state || "/";
  },
};

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
    <OrganizationProvider>
       <AppProvider>
        <VolumeProvider>
          <FileUploadProvider>
            <UnityProvider>
              <MeasurementsProvider>
                <TabProvider>
                  <ModalProvider>
                    <UnityActionsProvider>
                      <LocationsMenuProvider>
                        <MinifiedMenuItemsProvider>
                          <ScreenProvider>
                            <ProjectsCoordinatesProvider>
                              <CoordinatesProvider>
                                <DataProvider>
                                  <ContextProvider>
                                    <BrowserRouter basename={baseUrl}>
                                      <AiChatProvider>
                                        <App />
                                      </AiChatProvider>
                                    </BrowserRouter>
                                  </ContextProvider>
                                </DataProvider>
                              </CoordinatesProvider>
                            </ProjectsCoordinatesProvider>
                          </ScreenProvider>
                        </MinifiedMenuItemsProvider>
                      </LocationsMenuProvider>
                    </UnityActionsProvider>
                  </ModalProvider>
                </TabProvider>
              </MeasurementsProvider>
            </UnityProvider>
          </FileUploadProvider>
        </VolumeProvider>
      </AppProvider>
      </OrganizationProvider>
    </AuthProvider>
  </React.StrictMode >
);
